import { useState, useEffect } from "react"
import {
    getNotifications,
    clearNotification,
    clearAllNotifications,
} from "../services/chaperonConnector"
import { consoleLog } from "../utilities/helpers"

export function useNotifications(userId) {
    const [notifications, setNotifications] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    // Fetch notifications
    const fetchNotifications = async () => {
        if (!userId) {
            setNotifications([])
            return
        }

        setIsLoading(true)
        setError(null)

        try {
            const response = await getNotifications(userId, { limit: 50 })
            if (response.success) {
                setNotifications(response.data || [])
            } else {
                setError(response.message || "Failed to fetch notifications")
            }
        } catch (err) {
            consoleLog("Error fetching notifications:", err)
            setError("Error fetching notifications")
        } finally {
            setIsLoading(false)
        }
    }

    // Clear single notification
    const clearSingleNotification = async (notificationId) => {
        if (!userId) return

        try {
            const response = await clearNotification(userId, notificationId)
            if (response.success) {
                setNotifications((prev) =>
                    prev.filter((n) => n.id !== notificationId),
                )
            }
        } catch (err) {
            consoleLog("Error clearing notification:", err)
        }
    }

    // Clear all notifications
    const clearAll = async () => {
        if (!userId) return

        try {
            const response = await clearAllNotifications(userId)
            if (response.success) {
                setNotifications([])
            }
        } catch (err) {
            consoleLog("Error clearing all notifications:", err)
        }
    }

    // Fetch on mount and when userId changes
    useEffect(() => {
        fetchNotifications()
    }, [userId])

    return {
        notifications,
        isLoading,
        error,
        fetchNotifications,
        clearSingleNotification,
        clearAll,
    }
}
